import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Accordion, Table } from "onefaceui-react-components";

import { getResourceTo } from "react/utils/chatUtils";

const TimesSection = ({ route }) => {
  function getSafeDateValue(date) {
    if (!date) return '-';

    return Monet.Format.DateTime.formatToLocale(date);
  }

  return (
    <Accordion
      variant="transparent"
      size="sm"
      label={getResourceTo('Stop.popup.timesExpansionBox')}
      dataTestId={"times-section"}
    >
      <Table
        columns={[
          {
            title: getResourceTo('routePanel.times.event'),
            field: 'event',
            resizable: false,
            headerSort: false,
            hozAlign: 'center',
          },
          {
            title: getResourceTo('routePanel.times.baseline'),
            field: 'baseline',
            resizable: false,
            headerSort: false,
            hozAlign: 'center',
          },
          {
            title: getResourceTo('routePanel.times.planned'),
            field: 'planned',
            resizable: false,
            headerSort: false,
            hozAlign: 'center',
          },
          {
            title: getResourceTo('routePanel.times.projected'),
            field: 'projected',
            resizable: false,
            headerSort: false,
            hozAlign: 'center'
          },
          {
            title: getResourceTo('routePanel.times.actual'),
            field: 'actual',
            resizable: false,
            headerSort: false,
            hozAlign: 'center'
          }
        ]}
        defaultData={[
          {
            event: getResourceTo('routePanel.times.events.start'),
            baseline: getSafeDateValue(route?.baseLineStart),
            planned: getSafeDateValue(route?.plannedStart),
            projected: getSafeDateValue(route?.projectedStart),
            actual: getSafeDateValue(route?.actualStart),
          },
          {
            event: getResourceTo('routePanel.times.events.departure'),
            baseline: getSafeDateValue(route?.baseLineDeparture),
            planned: getSafeDateValue(route?.plannedDeparture),
            projected: getSafeDateValue(route?.projectedDeparture),
            actual: getSafeDateValue(route?.actualDeparture),
          },
          {
            event: getResourceTo('routePanel.times.events.arrival'),
            baseline: getSafeDateValue(route?.baseLineArrival),
            planned: getSafeDateValue(route?.plannedArrival),
            projected: getSafeDateValue(route?.projectedArrival),
            actual: getSafeDateValue(route?.actualArrival),
          },
          {
            event: getResourceTo('routePanel.times.events.complete'),
            baseline: getSafeDateValue(route?.baseLineComplete),
            planned: getSafeDateValue(route?.plannedComplete),
            projected: getSafeDateValue(route?.projectedComplete),
            actual: getSafeDateValue(route?.actualComplete),
          }
        ]}
        columnsPreference={[
          {
            field: 'event'
          },
          {
            field: 'baseline'
          },
          {
            field: 'planned'
          },
          {
            field: 'projected'
          },
          {
            field: 'actual'
          }
        ]}
      />
    </Accordion>
  )
};

TimesSection.propTypes = {
  route: PropTypes.object.isRequired
};

export default memo(TimesSection);
